let blockRedirectBanner = false;

$(document).ready(function() {

    if ($('.banner-slider').length) {
        $('.banner-slider .owl-carousel').each(function () {
            let $carousel = $(this);
            let isAnimating = false;

            $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: false,
                smartSpeed: 800,
                margin: 0,
                animateOut: 'fadeOut',
                animateIn: 'fadeIn',
                mouseDrag: false,
                touchDrag: false,
                onTranslate: function() { 
                    isAnimating = true;
                    $carousel.find('.aos-init').removeClass('aos-animate');

                    setTimeout(() => {
                        $carousel.find('.aos-init').addClass('aos-animate');
                    }, 500);
                },
                onTranslated: function() { 
                    isAnimating = false;
                }
            });

            let blockRedirect = false;

            $carousel.swipe({
                swipeLeft: function () {
                    if (!isAnimating) {
                        $carousel.trigger('next.owl.carousel');
                        blockRedirectBanner = true;
                    }
                },
                swipeRight: function () {
                    if (!isAnimating) {
                        $carousel.trigger('prev.owl.carousel');
                        blockRedirectBanner = true;
                    }
                }
            });

            setTimeout(() => {
                $carousel.find('.aos-init').addClass('aos-animate');
            }, 500);

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.banner-image-slider').length) {
        $('.banner-image-slider .owl-carousel').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: true,
                autoHeight: true,
                smartSpeed: 800,
                margin: 0,
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.product-slider').length) {
        $('.product-slider .owl-carousel').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                items: 3,
                nav: false,
                dots: false,
                loop: false,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 20,
                responsive: {
                    0: {
                        items: 1,
                        margin: 20,
                        stagePadding: 30
                    },
                    768: {
                        items: 2,
                        margin: 30,
                        stagePadding: 20
                    },
                    1250: {
                        items: 3,
                        margin: 30,
                        stagePadding: 20
                    }
                }
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.product-slider-v2').length) {
        $('.product-slider-v2 .owl-carousel').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                items: 4,
                nav: false,
                dots: false,
                loop: false,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 20,
                responsive: {
                    0: {
                        items: 1,
                        margin: 20,
                        stagePadding: 30
                    },
                    768: {
                        items: 2,
                        margin: 30,
                        stagePadding: 20
                    },
                    1250: {
                        items: 4,
                        margin: 30,
                        stagePadding: 20
                    }
                }
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.image-slider').length) {
        $('.image-slider .owl-carousel').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: false,
                loop: true,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 20,
                responsive: {
                    0: {
                        items: 1,
                        margin: 20,
                        stagePadding: 30
                    },
                    768: {
                        items: 1,
                        margin: 30,
                        stagePadding: 20
                    },
                    1250: {
                        items: 1,
                        margin: 30,
                        stagePadding: 20
                    }
                }
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.image-slider-small').length) {
        $('.image-slider-small .owl-carousel').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                items: 2,
                nav: false,
                dots: false,
                loop: true,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 20,
                responsive: {
                    0: {
                        items: 1,
                        margin: 20,
                        stagePadding: 30
                    },
                    768: {
                        items: 2,
                        margin: 30,
                        stagePadding: 20
                    },
                    1250: {
                        items: 2,
                        margin: 30,
                        stagePadding: 20
                    }
                }
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.video-slider').length) {
        $('.video-slider .owl-carousel').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                items: 4,
                nav: false,
                dots: false,
                loop: true,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 20,
                center: true,
                responsive: {
                    0: {
                        items: 1,
                        margin: 20,
                        stagePadding: 30
                    },
                    768: {
                        items: 3,
                        margin: 30,
                        stagePadding: 20
                    },
                    1250: {
                        items: 5,
                        margin: 30,
                        stagePadding: 20
                    }
                }
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.youtube-slider').length) {
        $('.youtube-slider .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: false,
                dots: true,
                smartSpeed: 800,
                margin: 30,
                responsive: {
                    0: {
                        items: 1,
                        margin: 20
                    },
                    768: {
                        items: 2,
                        margin: 20
                    },
                    1280: {
                        items: 3,
                        margin: 30
                    }
                }
            });
        });
    }

    if ($('.slider-gallery').length) {
        $('.slider-gallery .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            $carousel.owlCarousel({
                items: 5,
                nav: true,
                dots: false,
                loop: true,
                center: true,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 0,
                onInitialize: function() {
                    setTimeout(() => {
                        let centerH = $carousel.find('.owl-item.center .wrapper').outerHeight();
                        $carousel.find('.owl-stage').height(centerH);

                        let itemH = $carousel.find('.owl-item.center .item').outerHeight() / 2;
                        $floatNav.css('top', `${itemH}px`);
                    }, 1000);
                },
                onTranslate: function() {
                    $carousel.find('video').each(function () {
                        this.pause();
                        this.muted = true;
                    });
                    $carousel.find('.toggle-video').removeClass('unmute');
                },
                onTranslated: function() {
                    let video = $carousel.find('.owl-item.center').first().find('video').get(0);
                    if (video)
                        video.play();
                },
                responsive: {
                    0: {
                        items: 1,
                        stagePadding: 30
                    },
                    768: {
                        items: 3,
                        stagePadding: 30
                    },
                    1250: {
                        items: 5,
                        stagePadding: 0
                    }
                }
            });

            let video = $carousel.find('.owl-item.center').first().find('video').get(0);
            if (video)
                video.play();

            $floatNav.find('.owl-prev').on('click', function() {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                $carousel.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');

            $(window).resize(function() {
                setTimeout(() => {
                    let centerH = $carousel.find('.owl-item.center .wrapper').outerHeight();
                    $carousel.find('.owl-stage').height(centerH);

                    let itemH = $carousel.find('.owl-item.center .item').outerHeight() / 2;
                    $floatNav.css('top', `${itemH}px`);
                }, 500);
            });
        });
    }

    if ($('.image-link-slider').length) {
        $('.image-link-slider .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            $carousel.owlCarousel({
                items: 3,
                nav: true,
                dots: false,
                loop: false,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 0,
                responsive: {
                    0: {
                        nav: false,
                        items: 1,
                        margin: 20,
                        stagePadding: 30
                    },
                    768: {
                        nav: false,
                        items: 2,
                        margin: 20,
                        stagePadding: 30
                    },
                    1250: {
                        nav: true,
                        items: 3,
                        margin: 30,
                        stagePadding: 0
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                $carousel.trigger('next.owl.carousel');
            });

            if ($carousel.find('.owl-nav').hasClass('disabled'))
                $floatNav.hide();

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.image-slider-1-1').length) {
        $('.image-slider-1-1 .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            $carousel.owlCarousel({
                items: 3,
                nav: true,
                dots: true,
                loop: false,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 0,
                responsive: {
                    0: {
                        nav: false,
                        items: 1,
                        margin: 20,
                        stagePadding: 30
                    },
                    768: {
                        nav: false,
                        items: 2,
                        margin: 30,
                        stagePadding: 30
                    },
                    1250: {
                        nav: true,
                        items: 3,
                        margin: 30,
                        stagePadding: 0
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }

                updateProgress(event);
            });

            function updateProgress(event) {
                let total = event.item.count;
                let visible = event.page.size;
                let current = event.item.index + visible;

                if (current > total) current = total;

                let percent = (current / total) * 100;
                $carousel.parents('.image-slider-1-1').find('.bar').css('width', percent + '%');;
            }

            $floatNav.find('.owl-prev').on('click', function() {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                $carousel.trigger('next.owl.carousel');
            });

            if ($carousel.find('.owl-nav').hasClass('disabled'))
                $floatNav.hide();

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.page-slider').length) {
        $('.page-slider').each(function() {
            let el = $(this);
            
            let $carousel = el.find('.owl-carousel');
            let $floatNav = $carousel.next('.float-nav');

            $carousel.owlCarousel({
                items: 4,
                nav: true,
                dots: false,
                loop: false,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 0,
                responsive: {
                    0: {
                        nav: false,
                        items: 1,
                        margin: 20,
                        stagePadding: 30
                    },
                    768: {
                        nav: false,
                        items: 2,
                        margin: 20,
                        stagePadding: 30
                    },
                    1250: {
                        nav: true,
                        items: 4,
                        margin: 30,
                        stagePadding: 0
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                $carousel.trigger('next.owl.carousel');
            });

            if ($carousel.find('.owl-nav').hasClass('disabled'))
                $floatNav.hide();

            $(this).trigger('refresh.owl.carousel');

            $(window).scroll(function() {
                if (visiblePercent(el) > 50) {
                    el.find('.aos-init').addClass('aos-animate');

                    console.log(visiblePercent(el));
                }
            });
        });
    }

    if ($('.social-image-slider').length) {
        $('.social-image-slider').each(function() {
            let el = $(this);
            
            let $carousel = el.find('.owl-carousel');
            let $floatNav = $carousel.next('.float-nav');

            $carousel.owlCarousel({
                items: 4,
                nav: true,
                dots: false,
                loop: true,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 0,
                responsive: {
                    0: {
                        items: 1,
                        margin: 20,
                        stagePadding: 30
                    },
                    768: {
                        items: 2,
                        margin: 20,
                        stagePadding: 30
                    },
                    1250: {
                        items: 4,
                        margin: 30,
                        stagePadding: 0
                    }
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                $carousel.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.support-v2').length) {
        $('.support-v2 .owl-carousel').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                items: 5,
                nav: false,
                dots: true,
                loop: false,
                smartSpeed: 800,
                margin: 80,
                responsive: {
                    0: {
                        items: 1,
                        margin: 20
                    },
                    768: {
                        items: 3,
                        margin: 50
                    },
                    1250: {
                        items: 5,
                        margin: 80
                    }
                }
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.image-slider-16-9').length) {
        $('.image-slider-16-9 .owl-carousel').each(function () {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            $carousel.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                loop: true,
                smartSpeed: 800,
                margin: 30,
                stagePadding: 0,
                responsive: {
                    0: {
                        nav: false,
                        margin: 20,
                        stagePadding: 30
                    },
                    768: {
                        nav: false,
                        margin: 30,
                        stagePadding: 30
                    },
                    1250: {
                        nav: true,
                        margin: 30,
                        stagePadding: 0
                    }
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                $carousel.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                $carousel.trigger('next.owl.carousel');
            });

            if ($carousel.find('.owl-nav').hasClass('disabled'))
                $floatNav.hide();

            $(this).trigger('refresh.owl.carousel');
        });
    }

    support();
    grid_gallery();

});

$(window).scroll(function() {
    support();
    grid_gallery();
});

function support() {
    if ($('.support').length) {
        $('.support').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 50) {
                el.find('.aos-init').addClass('aos-animate');
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }
        });    
    }
}

function grid_gallery() {
    if ($('.grid-gallery').length) {
        $('.grid-gallery').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 30) {
                el.find('.aos-init').addClass('aos-animate');
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }
        });    
    }
}

$('.banner-slider .item').on('click', function(e) {

    if (blockRedirectBanner) {
        e.preventDefault();
        blockRedirectBanner = false;
        return;
    }

    let url = $(this).data('url');
    if (url) window.location.href = url;
});

$('.slider-gallery .item').on('click', function() {
    let $this = $(this).find('.toggle-video');
    let video = $this.parent().find('video')[0]; // current video
    let allVideos = $this.parents('.slider-gallery').find('video');

    allVideos.each(function() {
        if (this !== video) {
            this.pause();
            this.muted = true;
            $(this).siblings('.toggle-video').removeClass('unmute');
        }
    });

    $this.toggleClass('unmute');
    if ($this.hasClass('unmute')) {
        if (video) {
            video.play();
            video.muted = false;
        }
    } else {
        if (video) video.muted = true;
    }
});